import './App.css';
import React from 'react';
import { Container } from 'react-bootstrap';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ROUTES } from './helpers/constants/routes';
const App = () =>
(
  <Container>
    <Router>
      <Routes>
        {
          ROUTES.map((e, id) => (<Route key={id} path={e.path} element={e.page} />))
        }
      </Routes>
    </Router>
  </Container>
)


export default App;
